// extracted by mini-css-extract-plugin
export var copyableField = "_p6-4";
export var customerBadge = "_p6-0";
export var customerInfoTitle = "_p6-2";
export var details = "_p6-1";
export var dropdownContainer = "_p6-5";
export var dropdownImage = "_p6-6";
export var editAssigneeForm = "_p6-a";
export var editButton = "_p6-3";
export var email = "_p6-7";
export var hidden = "_p6-d";
export var input = "_p6-8";
export var saveButton = "_p6-b";
export var shopifyIcon = "_p6-c";
export var suggestionBadge = "_p6-e";
export var suggestionText = "_p6-f";
export var username = "_p6-9";